import {capitalizeFirst} from '@wandb/weave/common/util/string';

import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {LinePlotDisplayFnArgs} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

export const getGroupAggDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currGroupAggOption = currTemplateLinePlotSettings?.groupAgg;

  const newGroupAggOption = currWorkspaceLinePlotSettings?.groupAgg;
  const newGroupAggOptionValue =
    newGroupAggOption ?? DEFAULT_LINE_PLOT_SETTINGS.groupAgg;

  return {
    groupTitle: 'Grouping',
    label: 'Group aggregation',
    field: 'groupAgg' as keyof LinePlotTemplateSettings,
    currValue: currGroupAggOption,
    currDisplayValue:
      currGroupAggOption == null
        ? undefined
        : capitalizeFirst(currGroupAggOption),
    newValue: newGroupAggOptionValue,
    newDisplayValue: capitalizeFirst(newGroupAggOptionValue),
  };
};
